import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export function getInclude(arr1, arr2) {
  var temp = [];
  var _iterator = _createForOfIteratorHelper(arr2),
    _step;
  try {
    var _loop = function _loop() {
      var item = _step.value;
      arr1.findIndex(function (i) {
        return i === item;
      }) !== -1 ? temp.push(item) : '';
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
    // 半选
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (temp.length > 0 && temp.length < arr2.length) {
    return 2;
  } else if (temp.length == 0) {
    return 1; //不选
  } else if (temp.length == arr2.length) {
    return 3; //全选
  }
}
export function deleteInclude(arr1, arr2) {
  return arr1.filter(function (item) {
    return !arr2.includes(item);
  });
}